import {
  deleteStepLogMessagesByType as deleteStepLogMessagesByType,
  fetchAllStepLogMessages,
} from "./stepLogMessageClass";

export default class stepLogClass {
  constructor(keikkaId) {
    this.keikkaId = keikkaId;
    this.messages = [];
    this.token = undefined;
    this.socket = undefined;
    this.isLoaded = false;
    this.data = undefined;
  }
  async init(token, socket) {
    this.token = token;
    this.socket = socket;
    this.messages = await fetchAllStepLogMessages(this.keikkaId, token);
    this.isLoaded = true;
  }

  getStepLogTypeStatus(stepLogTypeId) {
    // if no messages, then return false
    if (this.messages == null) return { confirmDate: null, isConfirmed: false };
    // if no stepLogTypeId provided, then return false
    if (stepLogTypeId == null) return { confirmDate: null, isConfirmed: false };
    // get a list of messages with the given stepLogTypeId
    const _messagesList = this.messages.filter((msg) => msg.stepLogTypeId == stepLogTypeId);
    // if no messages with the given stepLogTypeId, then return false
    if (_messagesList.length == 0) return { confirmDate: null, isConfirmed: false };

    // define variables
    let lastConfirmDate = undefined;
    let firstConfirmDate = undefined;
    let firstFoundDate = undefined;
    let isConfirmed = false;
    let isFound = false;
    let data = undefined;

    // loop through messages and find the latest confirmDate starting from end of list
    for (let i = _messagesList.length - 1; i >= 0; i--) {
      isFound = true;
      data = _messagesList[i].data;
      // initialize confirmDate to the first confirmDate found
      if (_messagesList[i].confirmDate != null) {
        if (lastConfirmDate === undefined) lastConfirmDate = new Date(_messagesList[i].confirmDate);
        if (firstConfirmDate === undefined)
          firstConfirmDate = new Date(_messagesList[i].confirmDate);

        // if any message does not require confirmation, then the whole stepLogType is confirmed
        //if (!_messagesList[i].requireConfirm) isConfirmed = true;

        // compare confirmDate to the current confirmDate
        // confirmdate is the latest confirmDate found
        if (lastConfirmDate > _messagesList[i].confirmDate) {
          lastConfirmDate = new Date(_messagesList[i].confirmDate);
        }
        if (firstConfirmDate < _messagesList[i].confirmDate) {
          firstConfirmDate = new Date(_messagesList[i].confirmDate);
        }
      }
      if (firstFoundDate === undefined) firstFoundDate = new Date(_messagesList[i].entryTime);
      else if (firstFoundDate < _messagesList[i].entryTime)
        firstFoundDate = new Date(_messagesList[i].entryTime);

      if (!isConfirmed && (_messagesList[i].isConfirmed || !_messagesList[i].requireConfirm))
        isConfirmed = true;
    }

    return {
      confirmDate: lastConfirmDate ? new Date(lastConfirmDate) : null,
      lastConfirmDate: lastConfirmDate,
      firstConfirmDate: firstConfirmDate,
      firstFoundDate: firstFoundDate,
      isConfirmed: isConfirmed,
      isFound: isFound,
      data: data,
    };
  }

  deleteMessagesByType(stepLogTypeId) {
    let _messagesList = this.messages.filter((msg) => msg.stepLogTypeId != stepLogTypeId);
    this.messages = _messagesList;
    deleteStepLogMessagesByType(this.keikkaId, stepLogTypeId, this.socket);
  }
  get isTarjouspyyntö() {
    return this.getStepLogTypeStatus(27).isConfirmed;
  }
  get isTilausvahvistusLähetetty() {
    return this.getStepLogTypeStatus(20).isConfirmed;
  }
  get showVehicleInfo() {
    const _hideVehicle = this.getStepLogTypeStatus(28);
    const _hideVehicleConfirmed = _hideVehicle.isConfirmed;
    const _showVehicle = !_hideVehicleConfirmed;
    return _showVehicle;
  }

  // _isImported does not change, so it is cached
  _isImported = undefined;
  get isImported() {
    if (this._isImported == undefined) this._isImported = this.getStepLogTypeStatus(8);
    return this._isImported;
  }
}

export async function stepLog_listByKeikkas(keikkaIds, token) {
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      keikkaIds: keikkaIds,
    }),
  };
  const response = await fetch(
    import.meta.env.VITE_SERVER_URL + "/api/stepLog/listByKeikkas",
    requestOptions
  );
  if (!response.ok) return null;
  const data = await response.json();
  return data;
}
